var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlex = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 122,
  height: 78,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 1,
  y: 44.893,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeDasharray: "4 6",
  strokeLinecap: "round",
  strokeWidth: 2,
  rx: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 45,
  y: 44.893,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeDasharray: "4 6",
  strokeLinecap: "round",
  strokeWidth: 2,
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 89,
  y: 44.893,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeDasharray: "4 6",
  strokeLinecap: "round",
  strokeWidth: 2,
  rx: 2
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 45,
  y: 1.107,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeDasharray: "4 6",
  strokeLinecap: "round",
  strokeWidth: 2,
  rx: 2
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 89,
  y: 1.107,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeDasharray: "4 6",
  strokeLinecap: "round",
  strokeWidth: 2,
  rx: 2
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 1,
  y: 1.107,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeDasharray: "4 6",
  strokeLinecap: "round",
  strokeWidth: 2,
  rx: 2
})));
export default SvgFlex;